import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FiAward,
  FiBarChart2,
  FiGift,
  FiRadio,
  FiVolume2,
} from "react-icons/fi";
import { useGetEngageFeedQuery } from "../../api/engageApi";
import { highlightSummary, normalizePost, timeAgo } from "./constants";
import TileShell from "../DashboardTiles/TileShell";

const FEED_ARGS = { page: 0, size: 3 };

const POST_ICON = {
  KUDOS: { icon: FiAward, tone: "bg-amber-50 text-amber-600" },
  POLL: { icon: FiBarChart2, tone: "bg-violet-50 text-violet-600" },
  ANNOUNCEMENT: { icon: FiVolume2, tone: "bg-blue-50 text-blue-600" },
  BIRTHDAY: { icon: FiGift, tone: "bg-rose-50 text-rose-600" },
  WORK_ANNIVERSARY: { icon: FiAward, tone: "bg-emerald-50 text-emerald-600" },
};

const EngageHighlights = ({ className = "" }) => {
  const navigate = useNavigate();
  const { data, isLoading, isError } = useGetEngageFeedQuery(FEED_ARGS);

  const posts = (data?.items || []).map(normalizePost).filter(Boolean);

  if (isLoading || isError || posts.length === 0) return null;

  return (
    <TileShell
      icon={FiRadio}
      title="Engage"
      actionLabel="View all"
      onAction={() => navigate("/engage")}
      className={className}
    >
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {posts.map((post) => {
          const { text } = highlightSummary(post);
          const meta = POST_ICON[post.type] || POST_ICON.ANNOUNCEMENT;
          const Icon = meta.icon;
          return (
            <button
              key={post.id}
              type="button"
              onClick={() => navigate("/engage")}
              className="flex w-full items-start gap-3 rounded-xl border border-gray-100 bg-gray-50 p-3 text-left transition hover:border-blue-200 hover:bg-blue-50"
            >
              <span
                className={`grid h-8 w-8 flex-none place-items-center rounded-lg ${meta.tone}`}
              >
                <Icon size={15} />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-sm font-medium text-gray-700">
                  {text}
                </span>
                <span className="mt-0.5 block text-xs text-gray-400">
                  {timeAgo(post.createdAt)}
                </span>
              </span>
            </button>
          );
        })}
      </div>
    </TileShell>
  );
};

export default EngageHighlights;
